module.exports = __webpack_public_path__ + "static/media/img 2.356e5b8e.png";